import requestIdleCallbackManager from 'Lib/requestIdleCallbackManager';

const revokeObjectURL = (url: string) => {
  if (__CLIENT__ && url && URL) {
    requestIdleCallbackManager.addTask(() => URL.revokeObjectURL(url));
  }
};

export default revokeObjectURL;
